import { toast } from '../../../util/toast';
import { isServerError } from '../../../util/helpers';
import { mitApi } from '../../../store/modules/mit/api';
import { RefundMITBody } from '../../../store/modules/mit/types';

type UseRefundMITProps = {
  mitId: string;
};

export const useRefundMIT = ({ mitId }: UseRefundMITProps) => {
  const [refundMIT, { isLoading }] = mitApi.useRefundMITMutation();
  const onRefundMIT = async (amount: number) => {
    try {
      const body: RefundMITBody = {
        mitId,
        amount,
      };
      const response = await refundMIT(body).unwrap();
      if (response.status === 'Failed') {
        throw new Error(response.error);
      }
    } catch (err) {
      let errorMessage =
        'Something went wrong while refunding the Card on File Transaction, please try again later';
      if (isServerError(err) && err.data.message.includes('invalid partial amount')) {
        errorMessage = 'Invalid refund amount. Please try again with a lower amount.';
      }
      toast.error(errorMessage);
      throw err;
    }

    toast.success('Card on File Transaction successfully refunded.');
  };

  return {
    onRefundMIT,
    isLoading,
  };
};
